"use strict";

import _ from "lodash";

import "./historic-values-dialog.scss";
import "./historic-values-dialog-dark.scss";

class HistoricValuesDialogCtrl {
    constructor($mdDialog, locals) {
        this.$mdDialog = $mdDialog;
        this.locals = locals;
        this.yearsChanged = [];
    }
    $onInit() {
        this.years = {};
        this.locals.yearsAvailable.forEach((year) => {
            this.years[year] = _.get(this.locals, `cashBalance.${year}`, {
                ORIGINAL: 0
            });
        });
    }
    onSave() {
        this.$mdDialog.hide({
            cashBalance: this.years,
            yearsChanged: this.yearsChanged
        });
    }
    onChange(year) {
        if (this.yearsChanged.includes(year)) return;
        this.yearsChanged.push(year);
    }
    onCancel() {
        this.$mdDialog.cancel();
    }
}

angular.module("nucont.shared").controller("HistoricValuesDialogCtrl", [
    "$mdDialog",
    "locals",
    HistoricValuesDialogCtrl
]);
